/* eslint-disable */
const dispatch = require("d3-dispatch").dispatch;

module.exports = function () {

    let size = [256, 256],
        timer = null,
        random = Math.random,
        timeInterval = Infinity,
        entityList = [],
        event = dispatch("word", "end"),
        layout = {};

    layout.start = function () {
        let board = zeroArray(size[0] * size[1]),
            bounds = [{x: 0, y: 0}, {x: size[0], y: size[1]}],
            i = -1,
            tags = [],
            n = entityList.length,
            data = entityList;

        if (timer) clearInterval(timer);
        timer = setInterval(step, 0);
        step();

        return layout;

        function step() {
            const start = Date.now();
            while (Date.now() - start < timeInterval && ++i < n && timer) {
                const d = data[i];
                if (place(board, d)) {
                    tags.push(d);
                    event.call("word", layout, d);
                }
            }
            if (i >= n) {
                layout.stop();
                event.call("end", layout, tags, bounds);
            }
        }
    };

    layout.stop = function () {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
        return layout;
    };
    function place(board, tag) {
        tag.x = Math.round(size[0]/2 * random());
        for (let count = 0; count < 1000; count++) {
            if (!entityCollide(tag, board, size)) {
                if (collideRects(tag, size)) {
                    const w = tag.width,
                        h = tag.height;
                    const x0 = tag.x,
                        y0 = tag.y;
                    for (let j = 0; j <= h; j++) {
                        for (let i = 0; i <= w; i++) {
                            board[size[0] * (y0 + j) + (x0 + i)] = true;
                        }
                    }
                    return true;
                }
            }
            tag.x = Math.round(size[0] * random());
        }
        return false;
    }

    layout.size = function (_) {
        if (arguments.length) {
            size = [+_[0], +_[1]];
            return layout
        } else {
            return size;
        }
    };
    layout.entityList = function (_) {
        if (arguments.length) {
            entityList = _;
            return layout
        } else {
            return entityList;
        }
    };
    layout.on = function () {
        const value = event.on.apply(event, arguments);
        return value === event ? layout : value;
    };
    return layout;
};

function entityCollide(tag, board, size) {
    const w = tag.width,
        h = tag.height;
    const x0 = tag.x,
        y0 = tag.y;
    for (let j = 0; j <= h; j++) {
        for (let i = 0; i <= w; i++) {
            if (board[size[0] * (y0 + j) + (x0 + i)]) {
                return true;
            }
        }
    }
    return false;
}

function collideRects(tag, size) {
    return tag.x >= 0 && tag.x + tag.width <= size[0] && tag.y >= 0 && tag.y + tag.height <= size[1];
}

function zeroArray(n) {
    let a = [],
        i = -1;
    while (++i < n) a[i] = false;
    return a;
}
